import React, { useEffect, useMemo, useState } from "react";
import NumberFormat from "react-number-format";
import {
  baseCurrencyCode,
  validateDecimalSeparator,
  prefixCcySymbol,
  suffixCcySymbol,
} from "../../utils/Currency";
import { roundNumber } from "../../services/app";
import { useApp } from "../../contexts";
import { useNavigate } from "react-router-dom";

function Item(props) {
  const navigate = useNavigate();
  const { T, convertToLocalCurrency,formatLocalCurrency,
    getCurrency  } = useApp();
  const { data, type } = props;
  const [items, setItems] = useState([]);
  const [price, setPrice] = useState(0);
  const handleParentClick = (type) => {
    navigate(`/asset?type=character&gifttype=${type}`)
  };
  useEffect(() => {
    if (data) {
      if (data.rows && data.rows.length > 3) {
        setItems(data.rows.slice(0, 3));
      }else{
        setItems(data.rows);
      }
      setPrice(convertToLocalCurrency(
        data.totalUsd,
        'USD',
        getCurrency()
      ))
    }
  }, [data])

  const getRandomClass = (itemId) => {
    const arr = Array.from({ length: 7 }, (_, i) => i + 1);
    const random = itemId % 7;
    return `suzu-card-image-${arr[random]}`;
  }


  return (
    <>
      <div
        onClick={() => handleParentClick(type)}
        className={`flex justify-start items-center gap-[13px] py-[10px] lg:py-[15px] suzu_item_mb lg:grid lg:grid-cols-6 cursor-pointer`}
      >
        <div className="flex items-center lg:col-span-3 justify-start gap-[5px] lg:gap-[20px] xls:gap-[22px] flex-1">
          {items && items.length > 0 ? (
            <>
              {items.map((item, index) => (
                <div
                  className={`${getRandomClass(
                    item.id
                  )} rounded-full bg-[#f2f2f2] p-[5px] w-[37px] h-[37px] lg:rounded-[13px] lg:w-[114px] lg:h-[92px] xls:w-[136px] xls:h-[110px]`}
                >
                  <img
                    src={item.img}
                    className="object-contain w-full h-full"
                    alt=""
                  />
                </div>
              ))}
            </>
          ) : (
            <></>
          )}
          {data?.count > 3 && (
            <div className="rounded-full p-[5px] w-[37px] h-[37px]">
              <img
                src={"/assets/images/item-3d-more.svg"}
                className="object-contain  w-full h-full"
                alt=""
              />
            </div>
          )}
        </div>
        <div className="hidden lg:flex flex-col items-end justify-end min-w-[12%]">
          <div className="px-[10px] py-[2px] text-[13px] lg:text-[12px] xls:text-[13px] text-[#272729] rounded-[38px] bg-[#8181811a]">
            {type === 0 ? T("Tradeable") : T("Use only")}
          </div>
        </div>
        <div className="hidden lg:flex text-[#818181] text-[15px] lg:text-[14px] xls:text-[15px] font-[400] justify-end min-w-[12%]">
          {T("{number} editions").replace("{number}", data?.count)}
        </div>
        <div className="flex flex-col items-end lg:min-w-[12%]">
          {type === 0 && (
            <NumberFormat
              className="text-[#272729] text-[16px] xls:text-[20px] font-[600] tracking-[0.2px] "
              value={formatLocalCurrency(roundNumber(price, 2))}
              displayType={"text"}
              thousandSeparator={true}
              prefix={prefixCcySymbol(true, getCurrency())}
              suffix={suffixCcySymbol(true, getCurrency())}
              decimalScale={validateDecimalSeparator(
                baseCurrencyCode(true, getCurrency())
              )}
            />
          )}
          <div className="flex justify-end items-baseline gap-[10px] lg:mb-0">
            <div className="px-[10px] py-[2px] lg:hidden text-xs text-[#272729] rounded-[38px] bg-[#8181811a]">
              {type === 0 ? T("Tradeable") : T("Use only")}
            </div>
            <span className="text-[12px] text-[#818181] lg:hidden font-[400] leading-[15px] whitespace-nowrap">
              {T("{number} editions").replace("{number}", data?.count)}
            </span>
          </div>
        </div>
      </div>
    </>
  );
}

export default Item;
